import { PaginationFilters } from '@reliance/types/filters/PaginationFilters';
import type { Group } from '@reliance/types/models/MobileDevice';
import { useAsync } from 'react-async-hook';
import api from '../common/api';
import { PaginatedResponse } from '@reliance/types/responses/PaginatedResponse';

export const useMobileDeviceGroups = (filters?: PaginationFilters & { facilityId?: number }) =>
  useAsync<PaginatedResponse<Group>>(
    () =>
      api
        .get<PaginatedResponse<Group>>('/mobile-device/group', { params: filters })
        .then((r) => r.data),
    [filters]
  );
